module.exports = __webpack_public_path__ + "static/media/title_sliding.d9336feb.jpg";